import { render } from "./theImportanceOfAestheticEducation.vue?vue&type=template&id=0a268bee&scoped=true"
import script from "./theImportanceOfAestheticEducation.vue?vue&type=script&lang=js"
export * from "./theImportanceOfAestheticEducation.vue?vue&type=script&lang=js"

import "./theImportanceOfAestheticEducation.vue?vue&type=style&index=0&id=0a268bee&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a268bee"]])

export default __exports__